import { useMemo } from 'react';
import {
  canAccessAdminRoute,
  canManageAdminUsers,
  canManageRoles,
  canManageTasks,
  hasFeature,
  isAdminHeader,
  loadAdminCapabilities,
  type AdminSessionCapabilities,
} from '../utils/adminPermissions';

export function useAdminPermission() {
  const caps = useMemo(() => loadAdminCapabilities(), []);

  return {
    caps,
    isSuperAdmin: caps.isSuperAdmin,
    hasFullAccess: caps.hasFullAccess,
    canAccessRoute: (path: string) => canAccessAdminRoute(path, caps),
    canManageAdminUsers: () => canManageAdminUsers(caps),
    canManageTasks: () => canManageTasks(caps),
    canManageRoles: () => canManageRoles(caps),
    isAdminHeader: () => isAdminHeader(caps),
    hasFeature: (key: string) => hasFeature(caps, key),
    hasPermission: (name: string) =>
      caps.hasFullAccess || caps.isSuperAdmin || caps.permissionNames.includes(name),
  };
}

export type { AdminSessionCapabilities };
